'use client';

import { Drawer, Heading, TextPassage } from '@petsmart-ui/sparky';
import { type ReactElement } from 'react';

import { useWindowWidth } from '@libs/common-next';

import { OfferCardDetails } from './OfferCardDetails';
import { useOfferCardActions } from './useOfferCardActions';
import './OfferCardDrawer.scss';

export function OfferCardDrawer(): ReactElement | null {
    const { isMobile } = useWindowWidth();
    const { drawerOpen, handleCloseDrawer, selectedOffer } = useOfferCardActions();

    return (
        <Drawer
            align="right"
            className="c-offer-card-drawer progress-offer-drawer"
            dismissible
            isActive={drawerOpen}
            onClose={() => {
                handleCloseDrawer();
            }}
        >
            <Drawer.Header>
                <Heading tagName="h2" size="headline">
                    Offer details
                </Heading>
            </Drawer.Header>

            <Drawer.Body>
                <OfferCardDetails />
                <TextPassage className="offer-card-drawer-terms" capLinelength={false}>
                    <Heading
                        id="offer-card-drawer-terms-header"
                        size={isMobile ? 'body-bold' : 'body-lg-bold'}
                        tagName="h3"
                    >
                        Terms & conditions
                    </Heading>
                    {selectedOffer && <p className="offer-drawer-terms-description">{selectedOffer.disclaimer}</p>}
                </TextPassage>
            </Drawer.Body>
        </Drawer>
    );
}
